import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageLayout = ({ children }) => {
  let loc = useLocation()
  useEffect(() => {
    if(window.ReactNativeWebView){
      window.ReactNativeWebView.postMessage(loc.pathname)
    }
  }, [loc])
  return <>{children}</>;
};

export default PageLayout;
